import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoginWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.7344 21.875V20.3125H20.3125V4.6875H12.7344V3.125H20.3125C20.7292 3.125 21.0937 3.28125 21.4062 3.59375C21.7187 3.90625 21.875 4.27083 21.875 4.6875V20.3125C21.875 20.7292 21.7187 21.0937 21.4062 21.4062C21.0937 21.7187 20.7292 21.875 20.3125 21.875H12.7344ZM10.7031 17.0573L9.58333 15.9375L12.2396 13.2812H3.125V11.7187H12.1875L9.53125 9.0625L10.651 7.94271L15.2344 12.526L10.7031 17.0573Z",
		fill: "white"
	})
});
export default SvgLoginWhite;
